module.exports = __webpack_public_path__ + "static/img/mp3.a8be62b0.jpg";